import { useEffect, useRef, useState } from 'react';

import '../styles/componentStyles/Journal.css';

import { useTranslation } from 'react-i18next';

import { colours } from '../../assets/colours.js';
import { Button } from '../../shared/components/button/Button';
import { inh_and_enh } from '../../shared/components/data';
import { formatAssessmentDate } from '../../shared/util/helperfunctions';
import JournalItem from './JournalItem';

function JournalBlock(props) {
  const { t } = useTranslation();
  const [showEntries, setShowEntries] = useState([]);
  const [journals, setJournals] = useState();
  const [isTextClipped, setIsTextClipped] = useState(false);
  const textRefs = useRef([]);

  const getText = (id) => {
    let textLine = inh_and_enh.filter((el) => id === el.id);
    textLine = textLine[0].label;
    return textLine;
  };

  useEffect(() => {
    if (props.journalArr) {
      const cleanArr = props.journalArr.filter((entries) => entries.journal);
      setJournals(cleanArr);
    }
  }, [props.journalArr]);

  useEffect(() => {
    if (props.startWith) {
      setShowEntries(props.startWith);
    }
  }, [props.startWith]);

  useEffect(() => {
    const journalElements = document.getElementsByClassName('journal-content');
    if (journalElements && journalElements.length > 0) {
      setIsTextClipped(
        textRefs.current.map((textRef, index) => {
          if (textRef && textRef.scrollHeight > textRef.clientHeight) {
            journalElements[index].classList.add('clipped');
            return true;
          }
          return false;
        })
      );
    }
  }, [props.journalArr, journals?.length, showEntries]);

  const handleViewMore = () => {
    setShowEntries(() => showEntries + 4);
  };

  return (
    <>
      {journals &&
        journals.map((entry, index) => {
          if (index >= showEntries) return null;
          return (
            <div
              // Entries have no ids, the list is append only and refs, aria ids and the clipped
              // state array are all index aligned.
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              className={`chart-container tile ${props.width} fs-mask`}
              role="group"
              aria-labelledby={`${index}-journal-block-title ${index}-journal-block-date`}
            >
              <div className="title-container">
                <div className="title">
                  <div id={`${index}-journal-block-title`}>{t('D096')}</div>
                  <div className="lines-container">
                    {props.mentalWellbeing && <div className="mw-subt">{entry.value}</div>}
                    {entry.enhancers?.length > 0 && (
                      <JournalItem
                        factors={entry.enhancers}
                        getText={getText}
                        title={props.mentalWellbeing ? t('journal.entry.emotions') : t('D098')}
                        backgroundColor={colours.green}
                      />
                    )}
                    {entry.inhibitors?.length > 0 && (
                      <JournalItem
                        factors={entry.inhibitors}
                        getText={getText}
                        title={props.mentalWellbeing ? t('journal.entry.stressors') : t('D098')}
                        backgroundColor={colours.red}
                      />
                    )}
                  </div>
                </div>
                <div
                  className="date-box fs-mask"
                  style={{ color: `#fff` }}
                  id={`${index}-journal-block-date`}
                >
                  {formatAssessmentDate(entry.date.slice(0, 10)).slice(0, 6)}
                </div>
              </div>
              <div
                ref={(el) => {
                  textRefs.current[index] = el;
                }}
                className="journal-content fs-mask"
              >
                {entry.journal}{' '}
              </div>
              {isTextClipped[index] && (
                <button
                  type="button"
                  className="transparent-button"
                  onClick={() =>
                    props.openModal(
                      `${t('D096')} - ${formatAssessmentDate(entry.date).slice(0, -5)}`,
                      [entry.journal]
                    )
                  }
                >
                  {t('journal.read.more')}
                </button>
              )}
            </div>
          );
        })}
      <div className="journal-button-container">
        {journals?.length > 2 && (
          <Button onClick={handleViewMore} color="white">
            {t('generic.button.loadMore')}
          </Button>
        )}
      </div>
    </>
  );
}

export default JournalBlock;
